/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i.spacer[_ngcontent-%COMP%] {\n  line-height: 2em;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcGFnZXMvcmVjZWlwdC1leGFtaW5lLWR1cGxpY2F0ZXMvcmVjZWlwdC1leGFtaW5lLWR1cGxpY2F0ZXMuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGdCQUFnQjtBQUNsQiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3JlY2VpcHQtZXhhbWluZS1kdXBsaWNhdGVzL3JlY2VpcHQtZXhhbWluZS1kdXBsaWNhdGVzLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJpLnNwYWNlciB7XG4gIGxpbmUtaGVpZ2h0OiAyZW07XG59XG4iXX0= */"];
export { styles as styles };
